export const NEWS_API_PATH = {
  GET_NEWS: "/organization-user/news/",
  GET_FEATURED_NEWS: "/organization-user/news/featured/",
};
